<template>
  <div v-if="numero_gir_dni">
    <vs-checkbox
      :value="reserva_nodo.numero_gir_dni_checked"
      @input="numero_gir_dni_checked(index)"
      :disabled="reserva_nodo.cantidad > 0 ? true : false"
      style="margin-top: 10px; display: inline-block"
    ></vs-checkbox>
    <span style="vertical-align: super">He indicado mi número GIR y DNI </span>
  </div>
</template>

<script>
export default {
  name: "NumeroGirDni",
  props: {
    numero_gir_dni: Number,
    reserva_nodo: Object,
    index: Number,
  },
  data() {
    return {};
  },
  methods: {
    numero_gir_dni_checked(index) {
      this.$store.commit("numero_gir_dni_checked", {
        index: index,
      });
    },
  },
};
</script>
